import { Api, getCategories, Category } from "@api";
import { FilterType, Table } from "@components";
import { Cell, Row } from "@components/table/types";
import { Box, Button } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { M_TABLE_HEADERS_CATEGORIES } from "../constants";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { CategoryDetails } from "./detail";
import { useEffect } from "react";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { exportCategoriesToExcel } from "@api/excel-exporters/exportCategories";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_CATEGORIES.NAME },
  { data: M_TABLE_HEADERS_CATEGORIES.IS_ACTIVE },
  { data: M_TABLE_HEADERS_CATEGORIES.IS_MANUAL },
  { data: M_TABLE_HEADERS_CATEGORIES.BUSINESS_UNIT },
];

const formatBool = (status: boolean): string => {
  return status ? "Yes" : "No";
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

export type SelectedItem = {
  selectedItem: Category;
};

export const Categories: React.FC = () => {
  const [dataList, setTableData] = useState<Row<Category>[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [open, setOpen] = React.useState<boolean>(false);
  const [action, setAction] = React.useState<string>("Add");
  const [pending, setPending] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState<Category | undefined>(
    undefined
  );

  const updateData = () => {
    incrementCounter();
  };

  const handleClose = () => {
    setSelectedItem(undefined);
    setOpen(false);
  };

  const showModal = () => {
    setOpen(true);
  };

  const [counter, updateCounter] = React.useState(0);

  useEffect(() => {
    getCategories().then((req: Category[]) => {
      const requestsResponse = (req || []).map((r: Category, index) => {
        return {
          cells: [
            {
              data: r.name,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedItem(r);
                setAction("Edit");
                setOpen(true);
              },
            },
            { data: formatBool(r.isActive) },
            { data: formatBool(r.isManual) },
            { data: r.businessUnit?.name },
          ],
          data: r,
        };
      });
      setTableData(requestsResponse);
      setIsloading(false);
    });
  }, [counter]);

  const incrementCounter = () => {
    updateCounter(counter + 1);
  };

  let editModal = null;
  if (!!selectedItem) {
    editModal = (
      <CategoryDetails
        id={0}
        data={selectedItem}
        isOpen={open}
        onClickAdd={updateData}
        onClickClose={handleClose}
        action={action}
      />
    );
  }

  function handleExport() {
    exportCategoriesToExcel();
  }

  const pageName = "System Categories";
  return (
    <Box mt={2}>
      {editModal}
      <MaintenanceBreadcrumbs title={pageName} />
      <Button style={{ float: "right" }} onClick={handleExport}>
        EXPORT TO EXCEL
      </Button>
      <Table
        data={dataList}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[M_TABLE_HEADERS_CATEGORIES.NAME]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_CATEGORY_TOOLBAR"
        onClickAdd={updateData}
        loading={isLoading}
      />
    </Box>
  );
};
